import {
    ON_START_NEW_EVENT,
    ON_NEW_EVENT,
    ON_ERROR_NEW_EVENT,
    ON_START_GET_EVENT_ORGNR,
    ON_GET_EVENT_ORGNR,
    ON_ERROR_GET_EVENT_ORGNR,
    ON_START_GET_EVENT_ID,ON_GET_EVENT_ID,ON_ERROR_GET_EVENT_ID,
    ON_START_GET_EVENT_ID_REFRESH,ON_GET_EVENT_ID_REFRESH,ON_ERROR_GET_EVENT_ID_REFRESH,
    ON_START_GET_AVTAL_Event_ID,
    ON_GET_AVTAL_Event_ID,
    ON_ERROR_GET_AVTAL_Event_ID,
    ON_START_GET_EVENT_USER,
    ON_GET_EVENT_USER,
    ON_ERROR_GET_EVENT_USER,
    ON_START_GET_EVENT_USER_DATE,ON_START_GET_EVENT_USER_DATE1,
    ON_GET_EVENT_USER_DATE,
    ON_ERROR_GET_EVENT_USER_DATE,
    ON_START_EVENT_UPDATE,
    ON_EVENT_UPDATE,ON_START_EVENT_OMBOKA,
    ON_ERROR_EVENT_UPDATE,ON_SET_NULL_EVENT_DIALER,
    SET_ZERO_EVENT,
    ON_START_EVENT_UPDATE_AvtalId, ON_EVENT_UPDATE_AvtalId, ON_ERROR_EVENT_UPDATE_AvtalId,
    ON_START_GET_EVENT_HISTORY_ID,ON_GET_EVENT_HISTORY_ID,ON_ERROR_GET_EVENT_HISTORY_ID,
    ON_START_EVENT_COMMENT, ON_EVENT_COMMENT, ON_ERROR_EVENT_COMMENT,
    ON_START_EVENT_AVBOKA, ON_EVENT_AVBOKA, ON_ERROR_EVENT_AVBOKA,
    ON_START_EVENT_UPDATE_KOM, ON_EVENT_UPDATE_KOM, ON_ERROR_EVENT_UPDATE_KOM,
    ON_START_EVENT_UPDATE_NYTT, ON_EVENT_UPDATE_NYTT, ON_ERROR_EVENT_UPDATE_NYTT,
    ON_OPEN_FILTER_MOTE, ON_ClOSE_FILTER_MOTE,SET_EVENT_FILTER,SET_EVENTVY_TYPE,
    ON_START_GET_EVENT_DOKUMENT,ON_GET_EVENT_DOKUMENT,ON_ERROR_GET_EVENT_DOKUMENT,
    ON_START_GET_EVENT_SETTING,ON_GET_EVENT_SETTING,ON_ERROR_GET_EVENT_SETTING,
    ON_START_ADD_NEW_TAG_EVENT,
    ON_ADD_NEW_TAG_EVENT,SET_EVENTVY_PAGE_ROWS,
    ON_ERROR_ADD_NEW_TAG_EVENT,ON_START_GET_EVENT_USER_DONTREFRESH,
    ON_START_SYNK_ENENTS, ON_SYNK_ENENTS, ON_ERROR_SYNK_ENENTS,
    UNSET_EVENTVY_TYPE
} from "../constants/ActionTypes";
import {isUndefined} from 'lodash'
import { translate } from "../util/intlHelper";

const INIT_STATE = {
    EventListByOrgnr:[],
    EventListByAvtal:[],
    EventListByUser:[],
    EventListByUserDate:[],
    currentEvent:{},
    currentEventHisTory:[],
    HisToryIsLoading:true,
    isLoadingEvent:false,
    FilterEventPopup:false,
    Eventmessage:"",
    TotalEvent:{},
    EventDocument:[],
    EventFilterOption:isUndefined(localStorage.EventFilter)?[]:JSON.parse(localStorage.EventFilter), 
    currentEventVYIndex: 1,
    synckFlag:1,
    EventPageRows:25,
    visaOutlookSubject:0,
    visaGsuitSubject:0,
    CalendarSetting:[{Label:"Notyfile Möte",Color:'#009688'}]
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
      case SET_ZERO_EVENT:{
        return INIT_STATE;
      }
      case SET_EVENTVY_PAGE_ROWS:{
        localStorage.setItem("currentEventVYIndex", JSON.stringify(action.payload));
        return { ...state,
          EventPageRows: action.payload,
        };
      }
      case SET_EVENTVY_TYPE:{
        return { ...state,
          currentEventVYIndex: action.payload,
        };
      }
      case UNSET_EVENTVY_TYPE:{
        localStorage.removeItem("currentEventVYIndex");
        return { ...state,
          currentEventVYIndex: 1,
        };
      }
      case SET_EVENT_FILTER: {
        console.log("SET_EVENT_FILTER",action.payload)
        localStorage.removeItem("EventFilter");
        localStorage.setItem("EventFilter", JSON.stringify(action.payload));
        return { ...state,
          EventFilterOption: action.payload
        };
      }
      //
      case ON_START_GET_EVENT_HISTORY_ID:{
        console.log("ON_START_GET_EVENT_HISTORY_ID",action)
        return {
          ...state,
          Eventmessage:"",
          ResponseMsg:{msg:translate("Action.Event.History.fetching"),type:"info",loading:true}
        }
      }
    case ON_GET_EVENT_HISTORY_ID:{
        console.log("ON_GET_EVENT_HISTORY_ID",action)
        return {
          ...state,
          ResponseMsg:{},
          currentEventHisTory:action.payload.currentEventHisTory,
        }
      }
    case ON_ERROR_GET_EVENT_HISTORY_ID:{
        console.log("ON_ERROR_GET_EVENT_HISTORY_ID",action)
        return {
          ...state,
          ResponseMsg:{msg:translate("Error.Event.History.fetch"),type:"error",loading:true},
          Eventmessage:"",
          HisToryIsLoading:false
        }
      }
      //
      case ON_OPEN_FILTER_MOTE:{
        console.log("ON_OPEN_FILTER_MOTE",action)
        return {
          ...state,
          FilterEventPopup:true
        }
      }
    case ON_ClOSE_FILTER_MOTE:{
        console.log("ON_ClOSE_FILTER_MOTE",action)
        return {
          ...state,
          FilterEventPopup:false
        }
      }
        case ON_START_NEW_EVENT:{
            console.log("ON_START_NEW_EVENT",action)
            return {
              ...state,
              Eventmessage:"",
              isLoadingEvent:false,
              ResponseMsg:{msg:translate("Action.Event.Creating"),type:"info",loading:true},
             // currentEvent:{}
            }
          }
        case ON_NEW_EVENT:{
            console.log("ON_NEW_EVENT",action)
            return {
              ...state,
              //Eventmessage:translate("Action.Event.Save"),
              //isLoadingEvent:false,
              ResponseMsg:{msg:action.payload.message,type:"success",loading:false},
              currentEvent:action.payload.Event,
            }
          }
        case ON_ERROR_NEW_EVENT:{
            console.log("ON_ERROR_NEW_EVENT",action)
            return {
              ...state,
              ResponseMsg:{msg:translate("Error.Event.Create"),type:"error",loading:false},
              //Eventmessage:"Error",
              //isLoadingEvent:false,
              currentEvent:{}
            }
          }
        case ON_START_GET_EVENT_ORGNR:{
            console.log("ON_START_GET_EVENT_ORGNR",action)
            return {
              ...state,
              ResponseMsg:{msg:translate("Action.Event.Client.fetching"),type:"info",loading:true},
              Eventmessage:"",
              isLoadingEvent:false,
              currentEvent:{},
              TotalEvent:{},
              EventListByOrgnr:[]
            }
          }
        case ON_GET_EVENT_ORGNR:{
            console.log("ON_GET_EVENT_ORGNR",action)
            return {
              ...state,
              Eventmessage:"",
              isLoadingEvent:false,
              EventListByOrgnr:action.payload.Events,
              TotalEvent:action.payload.Antal,
              ResponseMsg:{}
            }
          }
        case ON_ERROR_GET_EVENT_ORGNR:{
            console.log("ON_ERROR_GET_EVENT_ORGNR",action)
            return {
              ...state,
              ResponseMsg:{msg:translate("Error.Event.Client.fetching"),type:"error",loading:true},
              Eventmessage:"",
              isLoadingEvent:false
            }
          }
        case ON_START_GET_EVENT_ID:{
            console.log("ON_START_GET_EVENT_ID",action)
            return {
              ...state,
              Eventmessage:"",
              isLoadingEvent:true,
              currentEvent:{},
              ResponseMsg:{msg:translate("Action.Event.fetching1"),type:"info",loading:true},
            }
          }
        case ON_GET_EVENT_ID:{
            console.log("ON_GET_EVENT_ID",action)
            return {
              ...state,
              isLoadingEvent:false,
              currentEvent:action.payload.Event,
              ResponseMsg:{},
            }
          }
        case ON_ERROR_GET_EVENT_ID:{
            console.log("ON_ERROR_GET_EVENT_ID",action)
            return {
              ...state,
              ResponseMsg:{msg:translate("Error.Event.fetch"),type:"error",loading:true},
              Eventmessage:"",
              isLoadingEvent:false,
              currentEvent:{}
            }
          }
          //ON_START_GET_EVENT_ID_REFRESH,ON_GET_EVENT_ID_REFRESH,ON_ERROR_GET_EVENT_ID_REFRESH
          case ON_START_GET_EVENT_ID_REFRESH:{
            console.log("ON_START_GET_EVENT_ID_REFRESH",action)
            return {
              ...state,
            }
          }
        case ON_GET_EVENT_ID_REFRESH:{
            console.log("ON_GET_EVENT_ID_REFRESH",action)
            return {
              ...state,
              currentEvent:action.payload.Event,
            }
          }
        case ON_ERROR_GET_EVENT_ID_REFRESH:{
            console.log("ON_ERROR_GET_EVENT_ID_REFRESH",action)
            return {
              ...state,
              ResponseMsg:{msg:action.payload,type:"error",loading:true},
              Eventmessage:""
            }
          }
          //
          case ON_START_GET_AVTAL_Event_ID:{
            console.log("ON_START_GET_AVTAL_Event_ID",action)
            return {
              ...state,
              ResponseMsg:{msg:translate("Action.Event.fetching"),type:"info",loading:true},
              Eventmessage:"",
              isLoadingEvent:false,
              currentEvent:{},
              EventListByAvtal:[]
            }
          }
        case ON_GET_AVTAL_Event_ID:{
            console.log("ON_GET_AVTAL_Event_ID",action)
            return {
              ...state,
              Eventmessage:"",
              ResponseMsg:{},
              isLoadingEvent:false,
              EventListByAvtal:action.payload.Events,
            }
          }
        case ON_ERROR_GET_AVTAL_Event_ID:{
            console.log("ON_ERROR_GET_AVTAL_Event_ID",action)
            return {
              ...state,
              ResponseMsg:{msg:translate("Error.Event.fetch"),type:"error",loading:true},
              Eventmessage:"",
              isLoadingEvent:false
            }
          }
          case ON_START_GET_EVENT_USER:{
            console.log("ON_START_GET_EVENT_USER",action)
            return {
              ...state,
              ResponseMsg:{msg:translate("Action.Event.fetching"),type:"info",loading:true},
              Eventmessage:"",
              isLoadingEvent:false,
              currentEvent:{},
              synckFlag:1
              //EventListByUser:[]
            }
          }
          case ON_START_GET_EVENT_USER_DONTREFRESH:{
            console.log("ON_START_GET_EVENT_USER",action)
            return {
              ...state,
              synckFlag:1
              //EventListByUser:[]
            }
          }
        case ON_GET_EVENT_USER:{
            console.log("ON_GET_EVENT_USER",action)
            return {
              ...state,
              Eventmessage:"",
              ResponseMsg:{},
              isLoadingEvent:false,
              EventListByUser:action.payload.Events,
              TotalEvent:action.payload.Antal,
            }
          }
        case ON_ERROR_GET_EVENT_USER:{
            console.log("ON_ERROR_GET_EVENT_USER",action)
            return {
              ...state,
              ResponseMsg:{msg:action.payload,type:"error",loading:false},
              Eventmessage:"",
              isLoadingEvent:false
            }
          }
          case ON_START_GET_EVENT_USER_DATE1:{
            console.log("ON_START_GET_EVENT_USER_DATE1",action)
            return {
              ...state,
              Eventmessage:"",
              visaOutlookSubject:0,
              visaGsuitSubject:0,
              isLoadingEvent:false,
              currentEvent:{},
              EventListByUserDate:[]
            }
          }
          case ON_START_GET_EVENT_USER_DATE:{
            console.log("ON_START_GET_EVENT_USER_DATE",action)
            return {
              ...state,
              Eventmessage:"",
              visaOutlookSubject:0,
              visaGsuitSubject:0,
              ResponseMsg:{msg:translate("Action.Event.fetching"),type:"info",loading:true},
              isLoadingEvent:false,
              currentEvent:{},
              EventListByUserDate:[]
            }
          }
        case ON_GET_EVENT_USER_DATE:{
            console.log("ON_GET_EVENT_USER_DATE",action)
            return {
              ...state,
              Eventmessage:"",
              isLoadingEvent:false,
              EventListByUserDate:action.payload.Events,
              visaOutlookSubject:action.payload.visaOutlookSubject,
              visaGsuitSubject:action.payload.visaGsuitSubject,
              TotalEvent:action.payload.Antal,
            }
          }
        case ON_ERROR_GET_EVENT_USER_DATE:{
            console.log("ON_ERROR_GET_EVENT_USER_DATE",action)
            return {
              ...state,
              ResponseMsg:{msg:translate("Error.Event.fetch"),type:"error",loading:true},
              Eventmessage:"",
              isLoadingEvent:false
            }
          }
          case ON_START_EVENT_UPDATE:{
            console.log("ON_START_EVENT_UPDATE",action)
            return {              
              ...state,
              ResponseMsg:{msg:translate("Action.Event.updating"),type:"info",loading:true},
              Eventmessage:"",
              isLoadingEvent:false,
            }
          }
        case ON_EVENT_UPDATE:{
            console.log("ON_EVENT_UPDATE",action)
            return {
              ...state,
              isLoadingEvent:false,
              ResponseMsg:{msg:translate("Action.Event.Save"),type:"success",loading:false},
              Eventmessage:"",
              currentEvent:action.payload.Event,
            }
          }
        case ON_ERROR_EVENT_UPDATE:{
            console.log("ON_ERROR_EVENT_UPDATE",action)
            return {
              ...state,
              ResponseMsg:{msg: translate("Error.Event"),type:"error",loading:true},
              Eventmessage:"",
              isLoadingEvent:false
            }
          } 
          //, , ,
          case ON_START_EVENT_AVBOKA:{
            console.log("ON_START_EVENT_AVBOKA",action)
            return {
              ...state,
              ResponseMsg:{msg:translate("Action.Event.Canceling"),type:"info",loading:true},
              Eventmessage:"",
              isLoadingEvent:false,
            }
          }
          case ON_START_EVENT_OMBOKA:{
            console.log("ON_START_EVENT_OMBOKA",action)
            return {
              ...state,
              ResponseMsg:{msg:translate("Action.Event.Rebooking"),type:"info",loading:true},
              Eventmessage:"",
              isLoadingEvent:false,
            }
          }
        case ON_EVENT_AVBOKA:{
            console.log("ON_EVENT_AVBOKA",action)
            return {
              ...state,
              isLoadingEvent:false,
              ResponseMsg:{msg:action.payload.message,type:"warning",loading:false},
              Eventmessage:"",
              currentEvent:action.payload.Event,
            }
          }
        case ON_ERROR_EVENT_AVBOKA:{
            console.log("ON_ERROR_EVENT_AVBOKA",action)
            return {
              ...state,
              ResponseMsg:{msg:action.payload,type:"error",loading:false},
              Eventmessage:"",
              isLoadingEvent:false
            }
          }  
          //
        //ON_START_EVENT_COMMENT, , ,
        case ON_START_EVENT_COMMENT:{
          console.log("ON_START_EVENT_COMMENT",action)
          return {
            ...state,
            ResponseMsg:{},
            Eventmessage:""
          }
        }
      case ON_EVENT_COMMENT:{
          console.log("ON_EVENT_COMMENT",action)
          return {
            ...state,
            ResponseMsg:{msg:action.payload.message,type:"success",loading:false},
            currentEvent:{
              ...state.currentEvent,
              Saljare:action.payload.Saljare
            }
          }
        }
      case ON_ERROR_EVENT_COMMENT:{
          console.log("ON_ERROR_EVENT_COMMENT",action)
          return {
            ...state,
            ResponseMsg:{msg:action.payload,type:"error",loading:true},
            Eventmessage:""
          }
        } 
        //, , ,
        case ON_START_EVENT_UPDATE_KOM:{
          console.log("ON_START_EVENT_UPDATE_KOM",action)
          return {
            ...state,
            ResponseMsg:{},
            Eventmessage:"",
            isLoadingEvent:false,
          }
        }
      case ON_EVENT_UPDATE_KOM:{
          console.log("ON_EVENT_UPDATE_KOM",action)
          return {
            ...state,
            isLoadingEvent:false,
            ResponseMsg:{msg:action.payload.message,type:"success",loading:false},
            Eventmessage:"",
            //currentEvent:action.payload.Event,
          }
        }
      case ON_ERROR_EVENT_UPDATE_KOM:{
          console.log("ON_ERROR_EVENT_UPDATE_KOM",action)
          return {
            ...state,
            ResponseMsg:{msg:action.payload,type:"error",loading:true},
            Eventmessage:"",
            isLoadingEvent:false
          }
        } 
        //, , ,
        case ON_START_EVENT_UPDATE_NYTT:{
          console.log("ON_START_EVENT_UPDATE_NYTT",action)
          return {
            ...state,
            ResponseMsg:{},
            Eventmessage:"",
            isLoadingEvent:false,
          }
        }
      case ON_EVENT_UPDATE_NYTT:{
          console.log("ON_EVENT_UPDATE_NYTT",action)
          return {
            ...state,
            isLoadingEvent:false,
            ResponseMsg:{msg:action.payload.message,type:"success",loading:false},
            Eventmessage:"",
          }
        }
      case ON_ERROR_EVENT_UPDATE_NYTT:{
          console.log("ON_ERROR_EVENT_UPDATE_NYTT",action)
          return {
            ...state,
            ResponseMsg:{msg:action.payload,type:"error",loading:true},
            Eventmessage:"",
            isLoadingEvent:false
          }
        }
        //, , ON_ERROR_EVENT_UPDATE_AvtalId,
        case ON_START_EVENT_UPDATE_AvtalId:{
          console.log("ON_START_EVENT_UPDATE_AvtalId",action)
          return {
            ...state,
            ResponseMsg:{},
            Eventmessage:"",
            isLoadingEvent:false,
          }
        }
      case ON_EVENT_UPDATE_AvtalId:{
          console.log("ON_EVENT_UPDATE_AvtalId",action)
          return {
            ...state,
            isLoadingEvent:false,
            ResponseMsg:{msg:action.payload.message,type:"success",loading:false},
            Eventmessage:"",
            //currentEvent:action.payload.Event,
          }
        }
      case ON_ERROR_EVENT_UPDATE_AvtalId:{
          console.log("ON_ERROR_EVENT_UPDATE_AvtalId",action)
          return {
            ...state,
            Eventmessage:"",
            ResponseMsg:{msg:action.payload,type:"error",loading:true},
            isLoadingEvent:false
          }
        }
        case ON_START_ADD_NEW_TAG_EVENT: {
          return {...state,
            ResponseMsg:{msg:translate("Action.Event.updating"),type:"info",loading:true},
            isLoadingEvent:false,
          }
        }
        case ON_ADD_NEW_TAG_EVENT: {
          return {...state,
            isLoadingEvent:false,
            ResponseMsg:{msg:translate("Action.Event.Save"),type:"success",loading:false},
            Eventmessage:"",
          }
        }
        case ON_ERROR_ADD_NEW_TAG_EVENT: {
          return {...state,
            Eventmessage:"Error",
            ResponseMsg:{msg: translate("Error.Event"),type:"error",loading:true},
            isLoadingEvent:false,
          }
        }
        //ON_SET_NULL_EVENT_DIALER
        case ON_SET_NULL_EVENT_DIALER: {
          return {
            ...state,
            currentEvent:{}
          }
        }
        //ON_START_GET_EVENT_DOKUMENT,ON_GET_EVENT_DOKUMENT,ON_ERROR_GET_EVENT_DOKUMENT,
        case ON_START_GET_EVENT_DOKUMENT: {
          return {...state}
        }
        case ON_GET_EVENT_DOKUMENT: {
          return {...state,
            EventDocument:action.payload.EventDocument,
          }
        }
        case ON_ERROR_GET_EVENT_DOKUMENT: {
          return {...state,
            ResponseMsg:{msg: translate("Error.Event"),type:"error",loading:true},
            Eventmessage:"Error"}
        }
        //ON_START_GET_EVENT_SETTING,ON_GET_EVENT_SETTING,ON_ERROR_GET_EVENT_SETTING,
        case ON_START_GET_EVENT_SETTING: {
          return {...state}
        }
        case ON_GET_EVENT_SETTING: {
          return {...state,
            CalendarSetting:action.payload.CalendarSetting,
          }
        }
        case ON_ERROR_GET_EVENT_SETTING: {
          return {...state}
        }
        //ON_START_SYNK_ENENTS, ON_SYNK_ENENTS, ON_ERROR_SYNK_ENENTS,
        case ON_START_SYNK_ENENTS: {
          return {
            ...state,
            ResponseMsg:{msg:translate("Action.Event.Syncing"),type:"info",loading:true},
            synckFlag:1
          }
        }
        case ON_SYNK_ENENTS: {
          return {
            ...state,
            ResponseMsg:{msg:translate("Action.Event.Sync"),type:"success",loading:false},
            synckFlag:2
          }
        }
        case ON_ERROR_SYNK_ENENTS: {
          return {...state,
            ResponseMsg:{msg:translate("Error.Event.Sync"),type:"error",loading:false},
            synckFlag:1,
            Eventmessage:""
          }
        }
        //
        default:
            return state;
    }
}
